import PricingPlan from '@repo/editor/src/components/PricingPlan/PricingPlan';
import { p3, h1, h3 } from '@repo/ui/components/Typography';
import { hideScrollBar } from '@repo/ui/components/utilities';
import { QUERIES } from '@repo/ui/queries';
import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

import { FlexRow } from 'styles/layouts';

// There was a z-index issue with the member select dropdown menu. To resolve
// this without re-architecting lots of components, a new stacking context
// created by this component is used.
export const StackingContext = styled.div`
  position: relative;
  z-index: 1;
  width: 100%;
`;

export const StyledPricingPlan = styled(PricingPlan).withConfig({
  shouldForwardProp: () => true,
})`
  width: 100%;
  scroll-snap-align: center;
  flex-shrink: 0;

  ${QUERIES.laptopAndUp} {
    width: auto;
  }
`;

export const PromoBadge = styled.span`
  ${p3}
  background-color: ${themeStyle.varBrandSuperLight};
  color: ${themeStyle.varBrandMain};
  border: 1px solid;
  padding: 0.4375rem 0.875rem;
  display: inline-block;
  /* Any value larger than the element's height works here */
  border-radius: 999px;
  line-height: 1;
`;

export const SwitchLabel = styled.span`
  font-size: ${themeStyle.fontSize14};
  color: ${themeStyle.varInkMain};
  font-weight: ${themeStyle.fontSemiBold};
`;

export const Headline = styled.div`
  ${h3}
  margin-top: 24px;
  margin-bottom: 14px;

  ${QUERIES.laptopAndUp} {
    ${h1}
    margin-top: 24px;
    margin-bottom: 38px;
  }
`;

export const PlanButtonRow = styled(FlexRow)`
  margin-top: 48px;
  margin-bottom: 24px;
  gap: 12px;

  ${QUERIES.laptopAndUp} {
    margin-top: 13px;

    > button {
      display: none;
    }
  }
`;

export const PlansContainer = styled(FlexRow)`
  ${hideScrollBar}
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  gap: 1.5rem;
  padding-left: 10px;
  padding-right: 10px;
  width: 100%;

  ${QUERIES.laptopAndUp} {
    justify-content: center;
    padding-left: 0;
    padding-right: 0;
  }
`;
